// extracted by mini-css-extract-plugin
export default {"main":"layout_main__x19xl"};